import React from "react";
import moment from "moment";
import List from "../../../components/list/List";
import mapDispatchToProps from "react-redux/es/connect/mapDispatchToProps";
import connect from "react-redux/es/connect/connect";
import { Link } from "react-router-dom";
import Redirect from "react-router/Redirect";

class History extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
      clickedVisitId: null
    };
  }

  render() {
    const { listHistory = [], loading, currentVisit } = this.props;
    return (
      <React.Fragment>
        <List
          loading={loading}
          data={listHistory.sort((a, b) => {
            if (a.startDate > b.startDate) return -1;
            if (a.startDate < b.startDate) return 1;
            return 0;
          })}
          columns={[
            {
              title: "Numéro",
              dataIndex: "_id",
              key: "_id",
              render: (text, record, index) => {
                return (
                  <div style={{ height: 36, paddingTop: 11 }}>
                    {!loading && (
                      <Link
                        to={{
                          pathname: `/visit/preview/${record._id}`
                        }}
                      >
                        {listHistory.length - index}
                      </Link>
                    )}
                  </div>
                );
              }
            },
            {
              title: "Date de la visite",
              dataIndex: "startDate",
              key: "startDate",
              render: (text, record, index) => {
                const style = {};
                if (record._id === currentVisit._id) {
                  style.color = "#0ea5d4";
                }
                return <div style={style}>{moment(text).format("DD/MM/YYYY HH:mm:ss")}</div>;
                return {
                  props: {
                    style: { "background-color": "#22AA00" }
                  },
                  children: <div>{moment(text).format("DD/MM/YYYY HH:mm:ss")}</div>
                };
              }
            }
          ]}
          onRowClick={(record, rowIndex) => {
            this.setState({
              redirect: true,
              clickedVisitId: record._id
            });
          }}
          rowClassName={record => {
            return record._id === currentVisit._id ? "visith-item active" : "visith-item";
          }}
        />
        {this.state.redirect && (
          <Redirect
            push
            to={{
              pathname: `/visit/preview/${this.state.clickedVisitId}` //state.state correspond à la visite sélectionnée
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

export default connect(null, mapDispatchToProps)(History);



// WEBPACK FOOTER //
// src/containers/activite/visit/PreviewListHistoryContainer.js